module.exports = __webpack_public_path__ + "15823dafac02674d7dfa13f30a04cd3e.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/right.png
// module id = 687
// module chunks = 0